import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, Typography } from '@mui/material';
import React from 'react';

const ShrinkableText = ({
  children,
  isShrunk,
  icon = <InfoOutlinedIcon />,
}) => {
  return isShrunk ? (
    <Tooltip title={children}>
      <div className='shrinkableText'>
        {icon}
      </div>
    </Tooltip>
  ) : (
    <div className='shrinkableText'>
      <Typography variant='body2' align='center'>{children}</Typography>
    </div>
  );
};

export default ShrinkableText;
